// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"757":"403bbf03","943":"8392a824"}[chunkId] + ".chunk.css";
};